import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const classes = {
  root: css`
    padding: ${spacing(0, 2)};
  `,
  // Floaty-режим (мобилка): бар закреплён внизу экрана поверх шторки, контент
  // скроллится под ним. Портал в контейнер DrawerOverlay — чтобы выйти из
  // transform/stacking шторки; перекрытие задаёт порядок DOM в контейнере
  // (шторка → бар → модалки), без z-index — CARGODEV-85875.
  // font-family возвращаем явно, т.к. вне шторки шрифт приложения не наследуется.
  floating: css`
    position: fixed;
    inset-inline: 0;
    inset-block-end: 0;
    padding: ${spacing(0, 2)};
    padding-block-end: env(safe-area-inset-bottom, 0px);
    background-color: var(--colorScheme-background, #ffffff);
    border-radius: ${spacing(3, 3, 0, 0)};
    filter: drop-shadow(0 -4px 16px rgb(0 0 0 / 12%));
    font-family: 'YS Text', 'Helvetica Neue', Arial, sans-serif;
  `,
}
